<template>
  <div class="expressao-valor">
    <div class="expr-toggle" role="tablist" aria-label="Tipo de expressão">
      <button
        type="button"
        class="expr-tab"
        role="tab"
        :aria-selected="value && value.tipo === 'literal'"
        :class="{ 'expr-tab--active': value && value.tipo === 'literal' }"
        @click="setTipo('literal')"
      >
        <fa-icon icon="font" /> Valor fixo
      </button>
      <button
        type="button"
        class="expr-tab"
        role="tab"
        :aria-selected="value && value.tipo === 'campo'"
        :class="{ 'expr-tab--active': value && value.tipo === 'campo' }"
        @click="setTipo('campo')"
      >
        <fa-icon icon="database" /> Campo da Verso
      </button>
    </div>

    <input
      v-if="value && value.tipo === 'literal'"
      class="form-control form-control-sm"
      :class="{ 'is-invalid': invalid }"
      type="text"
      :value="value.valor"
      :placeholder="placeholder || 'Valor literal'"
      @input="onLiteralInput"
    />

    <select
      v-else-if="value && value.tipo === 'campo'"
      class="form-control form-control-sm"
      :class="{ 'is-invalid': invalid }"
      :value="value.caminho"
      @change="onCampoChange"
    >
      <option value="">Selecione um campo da Verso</option>
      <option v-for="c in campos" :key="c.value" :value="c.value">{{ c.label }}</option>
    </select>

    <div class="expr-funcoes">
      <button type="button" class="expr-funcoes-toggle" @click="funcoesAbertas = !funcoesAbertas">
        <fa-icon :icon="funcoesAbertas ? 'chevron-down' : 'chevron-right'" />
        Funções{{ qtdFuncoes ? ` (${qtdFuncoes})` : '' }}
      </button>
      <FuncoesPipeline
        v-if="funcoesAbertas"
        :value="funcoesAtuais"
        @input="onFuncoesInput"
      />
    </div>
  </div>
</template>

<script>
import FuncoesPipeline from "../FuncoesPipeline";

export default {
  name: "ExpressaoValor",
  components: { FuncoesPipeline },
  props: {
    value: {
      type: Object,
      default: () => ({ tipo: "literal", valor: "" }),
    },
    campos: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "",
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      funcoesAbertas: false,
    };
  },
  computed: {
    funcoesAtuais() {
      return this.value && Array.isArray(this.value.funcoes) ? this.value.funcoes : [];
    },
    qtdFuncoes() {
      return this.funcoesAtuais.length;
    },
  },
  methods: {
    funcoesPreservadas() {
      return this.value && Array.isArray(this.value.funcoes) && this.value.funcoes.length
        ? { funcoes: this.value.funcoes }
        : {};
    },
    setTipo(tipo) {
      // Preserva o valor anterior quando possível — se o usuário trocou de
      // tipo por engano, basta voltar e o valor volta também. As funções de
      // formatação também são mantidas na troca.
      if (tipo === "literal") {
        this.$emit("input", { tipo: "literal", valor: (this.value && this.value.valor) || "", ...this.funcoesPreservadas() });
      } else {
        this.$emit("input", { tipo: "campo", caminho: (this.value && this.value.caminho) || "", ...this.funcoesPreservadas() });
      }
    },
    onLiteralInput(e) {
      this.$emit("input", { tipo: "literal", valor: e.target.value, ...this.funcoesPreservadas() });
    },
    onCampoChange(e) {
      this.$emit("input", { tipo: "campo", caminho: e.target.value, ...this.funcoesPreservadas() });
    },
    onFuncoesInput(funcoes) {
      const base = this.value && typeof this.value === "object" ? this.value : { tipo: "literal", valor: "" };
      this.$emit("input", { ...base, funcoes });
    },
  },
};
</script>

<style scoped>
.expressao-valor {
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* Largura fixa (≈ tamanho do campo), igual para Valor fixo/Campo — assim o
     toggle não estica a linha toda nem muda de tamanho ao trocar o tipo ou ao
     adicionar outra parte. */
  flex: 0 1 320px;
  min-width: 0;
}
.expr-toggle {
  display: flex;
  gap: 0;
  border: 1px solid var(--border-medium);
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}
.expr-tab {
  flex: 1;
  font-size: 12px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  transition: all 0.15s;
}
.expr-tab + .expr-tab { border-left: 1px solid var(--border-medium); }
.expr-tab:hover { background: var(--bg-subtle); }
.expr-tab--active {
  background: var(--primary);
  color: #fff;
  font-weight: 500;
}
.expr-tab--active:hover { background: var(--primary); }
.expr-funcoes {
  margin-top: 2px;
}
.expr-funcoes-toggle {
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  padding: 2px 0;
  display: flex;
  align-items: center;
  gap: 5px;
}
.expr-funcoes-toggle:hover {
  color: var(--primary);
}
</style>
